import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, ArrowRight, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function WaitlistForm({ source = "waitlist", testid = "waitlist" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/leads", { email, source });
      setDone(true);
      toast.success(data.message || "You're on the list!");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not sign you up");
    } finally {
      setLoading(false);
    }
  };

  if (done)
    return (
      <div className="flex items-center gap-2 font-mono2 text-sm text-primary" data-testid={`${testid}-done`}>
        <CheckCircle2 className="h-5 w-5" /> You're on the list — we'll be in touch.
      </div>
    );

  return (
    <form onSubmit={submit} className="flex w-full max-w-md gap-2" data-testid={`${testid}-form`}>
      <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com" data-testid={`${testid}-email`}
        className="rounded-sm border-border bg-background/60 focus:border-primary focus:ring-primary" />
      <Button type="submit" disabled={loading} data-testid={`${testid}-submit`}
        className="shrink-0 rounded-sm bg-primary font-mono2 uppercase tracking-widest text-black hover:bg-primary/90">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Join <ArrowRight className="ml-1 h-4 w-4" /></>}
      </Button>
    </form>
  );
}
